import { render, staticRenderFns } from "./Expert2RealEstateRequirementNewEdit.vue?vue&type=template&id=72642720&scoped=true&"
import script from "./Expert2RealEstateRequirementNewEdit.vue?vue&type=script&lang=js&"
export * from "./Expert2RealEstateRequirementNewEdit.vue?vue&type=script&lang=js&"
import style0 from "./Expert2RealEstateRequirementNewEdit.vue?vue&type=style&index=0&id=72642720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72642720",
  null
  
)

export default component.exports